import liffGeneralStoreInit from "./middlewares/liffGeneralStoreInit";
import ec91AppRedirectAuth from "./middlewares/web/ec91AppRedirectAuth";
import tongxinCheckWeb from "./middlewares/web/tongxinCheckWeb";
import tongxinRequireRegistered from "./middlewares/web/tongxinRequireRegistered";
import liffAuth from "./middlewares/liff/v2/auth";

export default [
  {
    path: "/:org_code/web/partner-marketing",
    meta: {
      middleware: [ec91AppRedirectAuth],
    },
    component: () =>
      import(
        /* webpackChunkName: 'WebPartnerMarketing' */ "@/pages/Web/PartnerMarketing/Layout.vue"
      ),
    children: [
      {
        path: "",
        name: "WebPartnerMarketingIndex",
        component: () =>
          import(
            /* webpackChunkName: 'WebPartnerMarketing' */ "@/pages/Web/PartnerMarketing/Index.vue"
          ),
      },
      {
        path: "product",
        name: "WebPartnerMarketingProduct",
        redirect: { name: "WebPartnerMarketingIndex" },
      },
      {
        path: "logs",
        name: "WebPartnerMarketingLogs",
        component: () =>
          import(
            /* webpackChunkName: 'WebPartnerMarketing' */ "@/pages/Web/PartnerMarketing/Logs.vue"
          ),
      },
      {
        path: ":id",
        name: "WebPartnerMarketingShow",
        component: () =>
          import(
            /* webpackChunkName: 'WebPartnerMarketing' */ "@/pages/Web/PartnerMarketing/Show.vue"
          ),
      },
    ],
  },
  {
    path: "/:org_code/web/proj/tongxin-demo",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: 'WebProjTongxinDemo' */ "@/pages/Web/proj/tongxin-demo/Layout.vue"
    ),
    children: [
      {
        path: "",
        name: "WebProjTongxinDemo",
        redirect: "step/exam-selection"
      },
      {
        path: "step/:stepId",
        name: "TongxinDemoStep",
        component: () =>
          import(
            /* webpackChunkName: 'WebProjTongxinDemoStep' */ "@/pages/Web/proj/tongxin-demo/DynamicStepContainer.vue"
          ),
        props: true
      },
      {
        path: "appointments",
        name: "TongxinAppointments",
        component: () =>
          import(
            /* webpackChunkName: 'WebProjTongxinAppointments' */ "@/pages/Web/proj/tongxin-demo/Appointments.vue"
          )
      }
    ],
  },
  {
    path: "/:org_code/web/proj/tongxin",
    meta: {
      middleware: [liffGeneralStoreInit, tongxinCheckWeb],
    },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: 'WebProjTongxin' */ "@/pages/Web/proj/tongxin/Layout.vue"
    ),
    children: [
      {
        path: "",
        name: "WebProjTongxin",
        redirect: (to) => {
          const basePath = to.path.replace(/\/+$/, '')
          // LINE LIFF 帶 liff.state 時，用 liff.state 的路徑做轉導（如 /reservations）
          // 沒有 liff.state 時，預設導去 step/exam-selection
          var liffState = to.query['liff.state']
          if (liffState) {
            var parsed = new URL(liffState, 'http://placeholder')
            // 將 liff.state 內的 query params 提取出來，與原本的 query 合併
            var mergedQuery = { ...to.query }
            parsed.searchParams.forEach(function (value, key) {
              mergedQuery[key] = value
            })
            return {
              path: basePath + parsed.pathname,
              query: mergedQuery
            }
          }
          return {
            path: basePath + '/step/exam-selection',
            query: to.query
          }
        }
      },
      {
        path: "step/:stepId/:categoryId?",
        name: "TongxinStep",
        meta: {
          middleware: [tongxinRequireRegistered],
        },
        component: () =>
          import(
            /* webpackChunkName: 'WebProjTongxinStep' */ "@/pages/Web/proj/tongxin/DynamicStepContainer.vue"
          ),
        props: true
      },
      {
        path: "family-selection",
        name: "TongxinFamilySelection",
        meta: {
          middleware: [tongxinRequireRegistered],
        },
        component: () =>
          import(
            /* webpackChunkName: 'WebProjTongxinFamily' */ "@/pages/Web/proj/tongxin/family/FamilyList.vue"
          )
      },
      {
        path: "reservations",
        name: "TongxinReservations",
        meta: {
          middleware: [tongxinRequireRegistered],
        },
        component: () =>
          import(
            /* webpackChunkName: 'WebProjTongxinReservations' */ "@/pages/Web/proj/tongxin/ReservationList.vue"
          ),
        props: true
      },
      {
        path: "reservations/search",
        name: "TongxinReservationSearch",
        meta: {
          middleware: [tongxinRequireRegistered],
        },
        component: () =>
          import(
            /* webpackChunkName: 'WebProjTongxinReservations' */ "@/pages/Web/proj/tongxin/ReservationSearch.vue"
          ),
        props: true
      },
      {
        path: "purpose",
        name: "TongxinPurpose",
        meta: {
          //middleware: [tongxinRequireRegistered],
        },
        component: () =>
          import(
            /* webpackChunkName: 'WebProjTongxinReservations' */ "@/pages/Web/proj/tongxin/Purpose.vue"
          ),
        props: true
      },
      {
        path: "reservations/:reservationId",
        name: "TongxinReservationDetail",
        meta: {
          middleware: [tongxinRequireRegistered],
        },
        component: () =>
          import(
            /* webpackChunkName: 'WebProjTongxinReservations' */ "@/pages/Web/proj/tongxin/ReservationDetail.vue"
          ),
        props: true
      },

      //醫師介紹頁
      {
        path: "appointment/doctor",
        name: "TongxinAppointmentDoctor",
        meta: {
          //middleware: [tongxinRequireRegistered],
        },
        component: () =>
          import(
            /* webpackChunkName: 'WebProjTongxin' */ "@/pages/Web/proj/tongxin/AppointmentDoctor.vue"
          )
      },
      
      // 資料設定
      {
        path: "setting",
        name: "TongxinSetting",
        component: () =>
          import(
            /* webpackChunkName: 'WebProjTongxinSetting' */ "@/pages/Web/proj/tongxin/Setting.vue"
          ),
      },
      // 解除綁定確認
      {
        path: "unbind",
        name: "TongxinUnbind",
        meta: {
          middleware: [tongxinRequireRegistered],
        },
        component: () =>
          import(
            /* webpackChunkName: 'WebProjTongxinUnbind' */ "@/pages/Web/proj/tongxin/Unbind.vue"
          ),
      },
      // 親友管理
      {
        path: "family",
        name: "TongxinFamilyList",
        meta: {
          middleware: [tongxinRequireRegistered],
        },
        component: () =>
          import(
            /* webpackChunkName: 'WebProjTongxinFamily' */ "@/pages/Web/proj/tongxin/family/FamilyList.vue"
          )
      },
      {
        path: "family/me",
        name: "TongxinFamilyMe",
        meta: {
          middleware: [tongxinRequireRegistered],
        },
        component: () =>
          import(
            /* webpackChunkName: 'WebProjTongxinFamily' */ "@/pages/Web/proj/tongxin/family/MyProfile.vue"
          )
      },
      {
        path: "family/me/add",
        name: "TongxinFamilyMeAdd",
        meta: {
          middleware: [tongxinRequireRegistered],
        },
        component: () =>
          import(
            /* webpackChunkName: 'WebProjTongxinFamily' */ "@/pages/Web/proj/tongxin/family/MyProfileForm.vue"
          )
      },
      {
        path: "family/member/:memberId",
        name: "TongxinFamilyMemberView",
        meta: {
          middleware: [tongxinRequireRegistered],
        },
        component: () =>
          import(
            /* webpackChunkName: 'WebProjTongxinFamily' */ "@/pages/Web/proj/tongxin/family/MemberProfile.vue"
          ),
        props: true
      },
      {
        path: "family/member/:memberId/edit",
        name: "TongxinFamilyMemberEdit",
        meta: {
          middleware: [tongxinRequireRegistered],
        },
        component: () =>
          import(
            /* webpackChunkName: 'WebProjTongxinFamily' */ "@/pages/Web/proj/tongxin/family/MemberForm.vue"
          ),
        props: true
      },
      {
        path: "family/add",
        name: "TongxinFamilyMemberAdd",
        meta: {
          middleware: [tongxinRequireRegistered],
        },
        component: () =>
          import(
            /* webpackChunkName: 'WebProjTongxinFamily' */ "@/pages/Web/proj/tongxin/family/MemberForm.vue"
          )
      },
      {
        path: "family/success",
        name: "TongxinFamilySuccess",
        meta: {
          middleware: [tongxinRequireRegistered],
        },
        component: () =>
          import(
            /* webpackChunkName: 'WebProjTongxinFamily' */ "@/pages/Web/proj/tongxin/family/Success.vue"
          )
      },
      // 切換院所 / 院區
      {
        path: "cresclab-menu",
        name: "TongxinCresclabMenu",
        meta: {
          middleware: [tongxinRequireRegistered],
        },
        component: () =>
          import(
            /* webpackChunkName: 'WebProjTongxin' */ "@/pages/Liff/Proj/Tongxin/CresclabMenu.vue"
          )
      },
      
    ],
  },
];
